import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52383476"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-md-4 mt-3 mb-3" }
const _hoisted_2 = ["href", "id"]
const _hoisted_3 = { class: "feature" }
const _hoisted_4 = { class: "image" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: _ctx.url,
      id: _ctx.id,
      target: "_blank"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", { src: _ctx.imageSrc }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.title), 1),
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.description), 1)
        ])
      ])
    ], 8, _hoisted_2)
  ]))
}